import React, { useEffect, useRef, useCallback } from 'react';
import { useDropdown } from '../../contexts/DropdownContext';
import DashboardDropdown, { DashboardDropdownOption, useDismissibleDropdown } from './DropdownFrame';

const Dropdown = ({ id, title, options }) => {
  const dropdownRef = useRef(null);
  const {
    getSelectedOption,
    setSelectedOption,
    openDropdown,
    closeDropdown,
    isDropdownOpen,
  } = useDropdown();
  const optionsVisible = isDropdownOpen(id);

  useEffect(() => {
    if (getSelectedOption(id) === null) {
      setSelectedOption(id, options[0]);
    }
  }, [getSelectedOption, id, options, setSelectedOption]);

  const closeOptions = useCallback(() => {
    closeDropdown(id);
  }, [closeDropdown, id]);

  useDismissibleDropdown(optionsVisible, dropdownRef, closeOptions);

  return (
    <DashboardDropdown
      title={title}
      value={getSelectedOption(id)}
      isOpen={optionsVisible}
      onToggle={() => {
        if (optionsVisible) {
          closeOptions();
          return;
        }
        openDropdown(id);
      }}
      dropdownRef={dropdownRef}
    >
      {options.map((option, index) => (
        <DashboardDropdownOption
          key={index}
          onClick={() => {
            setSelectedOption(id, option);
            closeOptions();
          }}
        >
          {option}
        </DashboardDropdownOption>
      ))}
    </DashboardDropdown>
  );
};

export default Dropdown;
